@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/text-helpers.scss';
@import 'apps/webcomponents/src/xdr/sensors/base/styles/common.scss';

.sensor-data-list {
  gz-form-field {
    flex: none;
  }
}

.sensor-data {
  padding-top: 0;
}

#label_for_gcp_file {
  font-size: var(--body-size-xsmall);
  color: var(--body-text-arrows-400);
}
